module.exports = __webpack_public_path__ + "img/img-survey-intro-01.b6a76fcf.png";